import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

export type SearchQuerySource = "searchbox" | "suggested" | "autocomplete"

export const SearchPageContainer = styled.div`
  min-height: 120px;
  width: 100%;
  background: ${colors.cloudWhite};
  border: 1px solid ${colors.white};
  border-radius: 16px;
  padding: 16px;
`
